import { useRef, useState, useCallback } from "react";
import { useTranslation } from "../i18n";
import "../styles/TvBootIntro.css";

const SESSION_KEY = "mxd_tv_on";

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default function TvBootIntro() {
  const { t } = useTranslation();
  const enteredRef = useRef(false);

  const [phase, setPhase] = useState(() => {
    try {
      return sessionStorage.getItem(SESSION_KEY) === "1" ? "done" : "standby";
    } catch {
      return "standby";
    }
  });

  const handleEnter = useCallback(() => {
    if (enteredRef.current) return;
    enteredRef.current = true;

    try {
      sessionStorage.setItem(SESSION_KEY, "1");
    } catch {}

    window.dispatchEvent(new Event("mxd:tv-on"));

    setPhase("booting");
    const duration = prefersReducedMotion() ? 280 : 1300;
    window.setTimeout(() => setPhase("done"), duration);
  }, []);

  if (phase === "done") return null;

  return (
    <div className={`tv-intro tv-intro--${phase}`} onClick={handleEnter}>
      {phase === "standby" && (
        <div className="tv-intro__standby">
          <img
            src="/files/images/mxd_logo.svg"
            alt="Mixordia"
            className="tv-intro__logo"
          />

          <button
            type="button"
            className="tv-intro__power-btn"
            aria-label={t("intro.ariaLabel")}
            autoFocus
          >
            <svg
              className="tv-intro__power-icon"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <line x1="12" y1="3" x2="12" y2="12" />
              <path d="M7.05 6.34a8 8 0 1 0 9.9 0" />
            </svg>
          </button>
        </div>
      )}

      <div className="tv-intro__line" />
      <div className="tv-intro__flash" />
    </div>
  );
}
